import { Layout } from './components/general/layout';
import Home from './components/home';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { AdminModalityList } from './components/pages/admin/modality/modality-list';
import { AdminClubList } from './components/pages/admin/club/club-list';
import { AdminSeasonList } from './components/pages/admin/season/season-list';
import { AdminCategoryList } from './components/pages/admin/category/category-list';
import { AdminTeamList } from './components/pages/admin/team/team-list';
import { AdminUserList } from './components/pages/admin/user/user-list';
import { ManagementAthleteList } from './components/pages/management/athletes/athlete-list';
import { ManagementTeamList } from './components/pages/management/team/team-list';
import { ManagementStaffList } from './components/pages/management/staff/staff-list';
import { CoachAthleteList } from './components/pages/coach/athletes/athlete-list';
import { AdminVideoList } from './components/pages/admin/video/video-list';
import { CoachTrainingTplList } from './components/pages/coach/training-tpl/training-tpl-list';
import { CoachTrainingSessionTplPhases } from './components/pages/coach/training-tpl/training-tpl-phases';
import { CoachTrainingList } from './components/pages/coach/training/training-list';
import { CoachTrainingSessionPhases } from './components/pages/coach/training/training-phases';
import { AthleteTrainingSessionView } from './components/pages/athlete/training/training-view';
import { AthleteVideoList } from './components/pages/athlete/videos/video-list';
import { AdminCompetitionList } from './components/pages/admin/competition/competition-list';
import { CompetitionView } from './components/pages/common/competition-view';
import { createContext, useEffect, useState } from 'react';
import { whoami } from './services/user';
import { emptyUser, User } from './interfaces/user';
import Login from './components/user/login';
import Reports from './components/pages/reports';
import { TeamView } from './components/pages/common/team-view';
import { AthleteView } from './components/pages/common/athlete-view';
import { AthletesRanking } from './components/pages/rankings/athletes-ranking';
import { TeamsRanking } from './components/pages/rankings/teams-ranking';
import { AthletesStatistics } from './components/pages/statistics/athletes-statistics';
import { TeamsStatistics } from './components/pages/statistics/teams-statistics';
import { AdminAthleteList } from './components/pages/admin/athletes/athlete-list';
import { CompetitionsEvents } from './components/pages/common/competitions-events';
import { AdminEventList } from './components/pages/admin/event/event-list';
import { EventView } from './components/pages/common/event-view';
import { ProgramList } from './components/pages/common/program/program-list';
import { ProgramMediaList } from './components/pages/common/program/program-media-list';
import { ProgramMediaView } from './components/pages/common/program/program-media-view';
import { AdminStaffList } from './components/pages/admin/staff/staff-list';
import { TrainingPlan } from './components/pages/coach/planning/planning';
import { ProgramMediaFolderView } from './components/pages/common/program/program-media-folder-view';
import { AdminSettings } from './components/pages/admin/settings/settings';

export const UserContext = createContext({userProfile: emptyUser});

function App() {
  const [user, setUser] = useState(emptyUser);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
      whoami()
        .then((whoamiResponse: any) => {
            const userProfile: User = {
                id: whoamiResponse.data.id,
                name: whoamiResponse.data.name,
                email: whoamiResponse.data.user_email,
                first_name: whoamiResponse.data.firstname,
                last_name: whoamiResponse.data.surname,
                birthdate: whoamiResponse.data.birthdate,
                phone: whoamiResponse.data.phone,
                document_id: whoamiResponse.data.document_id,
                description: whoamiResponse.data.description,
                slug: whoamiResponse.data.slug,
                role: whoamiResponse.data.role,
                // meta: whoamiResponse.data.meta.map((m: any) => { return m; }),
                avatar: whoamiResponse.data.avatar,
                club: whoamiResponse.data.club,
                teams: whoamiResponse.data.teams,
                status: whoamiResponse.data.status
            }
            if (userProfile.status == 0) {
                localStorage.removeItem('token');
            } else {
              setUser(userProfile);
              setLoaded(true);
            }
        })
        .catch(whoamiError => {
            console.log(whoamiError);
            setLoaded(true);
        });
  }, []);

  const handleLoginSuccess = (user: User) => {
    setUser(user);
  }

  return (
    <Router>
      <div className="App">
          <UserContext.Provider value={ {userProfile: user} }>
            { loaded && user.id == 0 &&
              <Login onLoginSuccess={ handleLoginSuccess } />
            }
            { loaded && user.id != 0 &&
              <Routes>
                <Route path="/" index element={<Home />} />
                
                <Route path="/" element={<Layout />}>
                  {/* Admin routes */}
                  <Route path="/admin/modality" element={<AdminModalityList />} />
                  <Route path="/admin/clubs" element={<AdminClubList />} />
                  <Route path="/admin/seasons" element={<AdminSeasonList />} />
                  <Route path="/admin/categories" element={<AdminCategoryList />} />
                  <Route path="/admin/staff" element={<AdminStaffList />} />
                  <Route path="/admin/teams" element={<AdminTeamList />} />
                  <Route path="/admin/athletes" element={<AdminAthleteList />} />
                  <Route path="/admin/competitions" element={<AdminCompetitionList />} />
                  <Route path="/admin/events" element={<AdminEventList />} />
                  <Route path="/admin/users" element={<AdminUserList />} />
                  <Route path="/admin/videos" element={<AdminVideoList />} />
                  <Route path="/admin/settings" element={<AdminSettings />} />

                  {/* Manager routes */}
                  <Route path="/manager/athletes" element={<ManagementAthleteList />} />
                  {/*<Route path="/manager/clubs" element={<Home />} />*/}
                  <Route path="/manager/teams" element={<ManagementTeamList />} />
                  <Route path="/manager/staff" element={<ManagementStaffList />} />
                  <Route path="/manager/videos" element={<AdminVideoList />} />
                  
                  {/* Coach routes */}
                  <Route path="/coach/athletes" element={<CoachAthleteList />} />
                  <Route path="/coach/training-session-tpls" element={<CoachTrainingTplList />} />
                  <Route path="/coach/training-session-tpls/:id/phases" element={<CoachTrainingSessionTplPhases />} />
                  <Route path="/coach/training-sessions" element={<CoachTrainingList />} />
                  <Route path="/coach/training-sessions/:id/phases" element={<CoachTrainingSessionPhases />} />
                  <Route path="/coach/videos" element={<AdminVideoList />} />
                  <Route path="/coach/planning" element={<TrainingPlan />} />
                  
                  {/* Athlete routes */}
                  <Route path="/athlete/training-sessions/:id/view" element={<AthleteTrainingSessionView />} />
                  {/*<Route path="/athlete/clubs" element={<Home />} />
                  <Route path="/athlete/teams" element={<Home />} />
                  <Route path="/athlete/athletes" element={<Home />} />
                  <Route path="/athlete/training-tpls" element={<Home />} />
                  <Route path="/athlete/training-session" element={<Home />} />*/}
                  <Route path="/athlete/videos" element={<AthleteVideoList />} />
                  
                  {/* Common routes */}
                  <Route path="/competitions-events" element={<CompetitionsEvents />} />
                  <Route path="/competitions/:id/view" element={<CompetitionView />} />
                  <Route path="/events/:id/view" element={<EventView />} />
                  <Route path="/teams/:id/view" element={<TeamView />} />
                  <Route path="/athletes/:id/view" element={<AthleteView />} />
                  <Route path="/training-session/:id/view" element={<AthleteView />} />
                  <Route path="/programs" element={<ProgramList />} />
                  {/*<Route path="/programs/:id" element={<ProgramMediaList />} />*/}
                  <Route path="/programs/:id" element={<ProgramMediaFolderView />} />
                  <Route path="/programs/media/:id" element={<ProgramMediaView />} />
                  <Route path="/reports" element={<Reports />} />

                  {/* Rankings */}
                  <Route path="/rankings/athletes" element={<AthletesRanking />} />
                  <Route path="/rankings/teams" element={<TeamsRanking />} />

                  {/* Statistics */}
                  <Route path="/statistics/athletes" element={<AthletesStatistics />} />
                  <Route path="/statistics/teams" element={<TeamsStatistics />} />
                </Route>
              </Routes>
            }
          </UserContext.Provider>
      </div>
    </Router>
  );
}

export default App;
